var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExportPanel',{attrs:{"uploading":_vm.uploading,"save_hash":_vm.save_hash},on:{"local-export":function($event){return _vm.exportGameSave(_vm.save_key)},"cloud-export":function($event){return _vm.uploadGameSave(_vm.save_key)}}})}
var staticRenderFns = []

export { render, staticRenderFns }